import React from 'react';

import { Link } from 'react-router-dom';

import './quick-nav-links.css';

const Component = (props) => {
    const { links, external } = props;
    return (
        <div className="quicklinks">
            <p className="d-none d-sm-block">
                <i className="fas fa-external-link-alt" />
                {external ? (
                    <span>
                        &nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;
                        <Link to={`${process.env.PUBLIC_URL}/`}>Home</Link>
                    </span>
                ) : (
                    ''
                )}
                {links.map((link) => {
                    return (
                        <span key={link.link}>
                            &nbsp;&nbsp;&bull;&nbsp;&nbsp;
                            {link.link.includes('://') ? (
                                <a target="blank" href={link.link}>
                                    {link.name}
                                </a>
                            ) : (
                                <Link target="_blank" to={`${process.env.PUBLIC_URL}/${link.link}`}>
                                    {link.name}
                                </Link>
                            )}
                        </span>
                    );
                })}
            </p>
            <div className="row d-sm-none">
                <div className="row">
                    <div className="col-1">
                        <i className="fas fa-external-link-alt quicklinks-iul" />
                    </div>
                    <div className="col-11">
                        <ul className="quicklinks-iul">
                            {external ? (
                                <li>
                                    <Link to={process.env.PUBLIC_URL}>Home</Link>
                                </li>
                            ) : (
                                ''
                            )}
                            {links.map((link) => {
                                return (
                                    <li key={link.link}>
                                        {link.link.includes('://') ? (
                                            <a target="blank" href={link.link}>
                                                {link.name}
                                            </a>
                                        ) : (
                                            <Link
                                                target="_blank"
                                                to={`${process.env.PUBLIC_URL}/${link.link}`}
                                            >
                                                {link.name}
                                            </Link>
                                        )}
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Component;
